<template>
  <carousel
    :perPageCustom="pageCustom"
    :autoplayTimeout="speed"
    :scrollPerPage="false"
    :paginationEnabled="false"
    :navigationEnabled="true"
    :autoplay="true"
    :autoplayHoverPause="true"
    :loop="true"
    class="mx-auto"
    :navigation-next-label="carouselSlideNext"
    :navigation-prev-label="carouselSlidePrev"
  >
    <slide v-for="item in list" :key="item.id" class="brands-carousel">
      <div class="card" @click="selected(item)">
        <div class="box">
          <div class="img center">
            <img :src="item.logo" :alt="item.name" />
          </div>
          <div class="modal-content">
            <p v-if="item.iphname">{{item.iphname}}</p>
            <p v-else>{{item.name}}</p>
          </div>
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { mapState } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import ChevronRight from "./assets/chevron-sign-right.svg";
import ChevronLeft from "./assets/chevron-sign-left.svg";

export default {
  components: {
    Carousel,
    Slide
  },
  props: ["pageCustom", "speed"],
  data: function() {
    return {
      filter: "",
      filterList: []
    };
  },
  computed: {
    ...mapState({
      list: state => state.brands.list
    }),
    carouselSlideNext() {
      const chevronRight = ChevronRight;
      return `<img src="${chevronRight}" class="navigation-chevron"/>`;
    },
    carouselSlidePrev() {
      const chevronLeft = ChevronLeft;
      return `<img src="${chevronLeft}" class="navigation-chevron"/>`;
    }
  },
  name: "ItemCarousel",
  watch: {
    filter: function() {
      this.filteringList();
    },
    list: function() {
      this.filteringList();
    }
  },
  methods: {
    filteringList() {
      this.filterList = this.list.filter(
        b =>
          b.name.toLowerCase().indexOf(this.filter.toLowerCase()) == 0 ||
          (b.iphname &&
            b.iphname.toLowerCase().indexOf(this.filter.toLowerCase()) == 0)
      );
    },
    selected(brand) {
      this.$store.dispatch("brands/selected", { brand: brand, top: false });
      this.$router.replace({ name: "searchPage" });
    }
  },
  beforeMount() {
    this.$store.dispatch("brands/requestData");
  }
};
</script>





// WEBPACK FOOTER //
// src/components/brands/src/BrandCarousel.vue